import ChangelogEntriesAPI from '../../../api/changelogEntries';

export const actions = {
  async fetch({ commit }, params = {}) {
    commit('SET_CHANGELOG_UI_FLAG', { isFetching: true });
    try {
      const { data } = await ChangelogEntriesAPI.get(params);
      commit('SET_CHANGELOG_ENTRIES', data.data || []);
      commit('SET_CHANGELOG_META', data.meta || {});
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('[ChangelogEntries] Failed to fetch:', error);
    } finally {
      commit('SET_CHANGELOG_UI_FLAG', { isFetching: false });
    }
  },

  async fetchUnreadCount({ commit }) {
    try {
      const { data } = await ChangelogEntriesAPI.getUnreadCount();
      commit('SET_CHANGELOG_UNREAD_COUNT', data.unread_count || 0);
    } catch (error) {
      // Silently fail — non-critical
    }
  },
};
